import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

import socket from '../../utils/socket';

const initialState = {
  isLoading: false,
  error: false,
  quotes: [],
  holidays: [],
  quote: null,
  year: [moment().format('YYYY')],
  years: [moment().format('YYYY')],
  quoteStack: [],
  simulatedShifts: [],
  yearMonthPicker: moment().startOf('month').toDate()
};

const slice = createSlice({
  name: 'quotes',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    },

    addQuoteStack(state, action) {
      state.quoteStack = [...state.quoteStack, action.payload];
    },
    removeQuoteStack(state, action) {
      state.quoteStack = state.quoteStack.filter((el) => el.index !== action.payload);
    },
    resetQuoteState(state) {
      state.quoteStack = initialState.quoteStack;
      state.simulatedShifts = initialState.simulatedShifts;
      state.yearMonthPicker = moment().startOf('month').toDate();
    },
    setQuotes(state, action) {
      const { quotes, holidays } = action.payload;
      state.quotes = quotes;
      state.holidays = holidays;
      state.isLoading = false;
    },
    updateQuote(state, action) {
      const { id, status } = action.payload;
      const array = state.quotes;
      const quoteToUpdate = array.filter((el) => el.quote_id === id)[0];
      quoteToUpdate.quote_status = status === 3 ? 'Accepté' : 'Refusé';
      state.quote = quoteToUpdate;
    },
    setSelectedQuote(state, action) {
      state.quote = action.payload;
    },
    setYears(state, action) {
      state.years = action.payload;
    },
    setYear(state, action) {
      state.year = action.payload;
    },
    setYearMonthPicker(state, action) {
      state.yearMonthPicker = action.payload;
    },
    makeSimulation(state, action) {
      const shifts = action.payload;
      state.simulatedShifts = shifts;
    },
    insertDemand(state, action) {
      state.quotes = [action.payload, ...state.quotes];
    }
  }
});

// Reducer
export default slice.reducer;
// actions
export const {
  addQuoteStack,
  makeSimulation,
  removeQuoteStack,
  resetQuoteState,
  setSelectedActivity,
  setWorkedDays,
  setYear,
  setYearMonthPicker,
  setSelectedQuote
} = slice.actions;

export function getQuotes() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/quotes');
      dispatch(slice.actions.setQuotes(result));
      dispatch(slice.actions.setYears(result.years));
      if (result.years.length) {
        dispatch(slice.actions.setYear([result.years[0]]));
      } else {
        dispatch(slice.actions.setYear([]));
      }

      if (result.quotes.length) {
        dispatch(slice.actions.setSelectedQuote(result.quotes[0]));
      } else {
        dispatch(slice.actions.setSelectedQuote([]));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateQuote(form, callback) {
  return async (dispatch) => {
    try {
      const resultUpdate = await socket.put('/quotes', {
        id: form.id,
        status: form.status,
        client_id: form.client_id,
        site_id: form.site_id
      });
      if (resultUpdate.success) {
        dispatch(slice.actions.updateQuote({ id: form.id, status: form.status }));
        callback(resultUpdate.success);
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function insertDemand(form, callback) {
  return async (dispatch) => {
    try {
      const result = await socket.post('/quotes', form);
      if (result.success) {
        callback();
        dispatch(slice.actions.insertDemand(result.newDemand));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
